/** Replace with the live checkout URL for Dance Class Ready (platform pending). Shared by every buy button. */
export const CHECKOUT_URL = '#pricing'
